import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'omni-inconsistencia',
  templateUrl: './inconsistencia.component.html',
  styleUrls: ['./inconsistencia.component.styl']
})
export class InconsistenciaComponent {

  constructor(
    private dialogRef: MatDialogRef<InconsistenciaComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {}

  obterTitulo = () => this.data.titulo;
  obterLabel = () => this.data.label;
  obterTexto = () => this.data.texto;
  obterIcone = () => this.data.icone;
  obternomeBotaoConfirmar = () => this.data.nomeBotaoConfirmar;
  mostrarBotaoCancelar = () => this.data.nomeBotaoCancelar;
  obternomeBotaoCancelar = () => this.data.nomeBotaoCancelar;


}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/modal-inconsistencia/inconsistencia.component.ts